import { createQueryParams } from '@/_utils/createQueryParams';
import { BagPaymentListApiService } from '@/bag/bag-payment-list/bag-payment-list-api.service';
import { BagPaymentBankAccount } from '@/bag/bag-payment-list/bag-payment-list.model';
import { LoaderService } from '@/common/loader/loader.service';
import { Component, inject, input, output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { BagPaymentListAddModalComponent } from './bag-payment-list-add-modal/bag-payment-list-add-modal.component';

@Component({
	selector: 'app-bag-payment-list-add',
	templateUrl: './bag-payment-list-add.component.html',
	styleUrls: ['./bag-payment-list-add.component.scss'],
})
export class BagPaymentListAddComponent {
	readonly bankAccounts = input<BagPaymentBankAccount[]>([]);
	readonly paymentsChanged = output<void>();

	private readonly dialog = inject(MatDialog);
	private readonly loader = inject(LoaderService);
	private readonly bagPaymentListApiService = inject(BagPaymentListApiService);

	openDialog(): void {
		this.loader.show();
		firstValueFrom(this.bagPaymentListApiService.getProfileData(createQueryParams({}, '999')))
			.then((profileData) => {
				this.loader.hide();
				const dialogRef = this.dialog.open(BagPaymentListAddModalComponent, {
					width: '90vw',
					maxWidth: '1400px',
					maxHeight: '90vh',
					data: {
						bankAccounts: this.bankAccounts(),
						profileData,
					},
				});

				dialogRef.afterClosed().subscribe((result) => {
					if (result === 'send') {
						this.paymentsChanged.emit();
					}
				});
			})
			.catch(() => {
				this.loader.hide();
			});
	}
}
